<template>
  <div class="d-flex">
    <div class="to-cart">
      <div @click="goToCart(services)" style="cursor: pointer; color:#fff;">
        <p v-if="services.discount === 1">{{Lang.get('js.services.buy')}}</p>
        <p v-else>{{Lang.get('js.services.buy_without_discount')}}</p>
        <div class="d-flex">
          <span v-if="services.discount === 1" class="my-button cart-icon blink" style="text-align: center" v-html="getPriceWithDiscount(services.price) + ' грн.'"></span>
          <span v-else class="my-button cart-icon blink" style="text-align: center" v-html="services.price + ' грн.'"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
      name: 'service-page',
      props: {
          services: {
              required: true
          }
      },
      data() {
          return {
              cart: window.cart,
              Lang,
              defaultLanguage,
          }
      },
      methods: {
          getPriceWithDiscount(initPrice) {
              initPrice = Math.round(parseFloat(initPrice * (100 - 10))) / 100;
              return initPrice;
          },
          // goToCart(code) {
          //     let url = 'http://artmediuz.medcloud.pro/?tests=' + code + '&tab=cart';
          //     window.open(url, '_blank');
          // },
          goToCart(service) {

            let price_with_discount = this.getPriceWithDiscount(service.price);
            if(service.discount === 0) {
              price_with_discount = service.price;
            }

              this.cart.addToCart(service, price_with_discount);
          },
      },
    mounted() {
      console.log(this.services);
    }
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/service/ServicePage.vue